export enum Role {
  SYSTEM_ADMIN = 'SystemAdmin',
  TENANT_ADMIN = 'TenantAdmin',
  MULTI_TENANTS_ADMIN = 'MultiTenantsAdmin',
}
